import CodeMirror from 'codemirror';
import 'codemirror/mode/yaml/yaml.js';
import 'codemirror/mode/javascript/javascript.js';

export default class CatalogPlan {
  constructor() {
    this.form = document.getElementById('catalog_update_plan_recurring') || document.getElementById('catalog_update_plan_one_time');

    if (this.form) {
      this.validator = window.solodev.formValidators[this.form.id];
      // This is callback called by header button.
      window.solodev.submitForm = () => this.form.submit();

      this.initForm();
    }

    this.initiated = false;
  }

  initForm() {
    const self = this;
    const typeInputRadios = this.form.querySelectorAll('.js-fulfillment-type .form-check-input');
    if (typeInputRadios.length) {
      for (const input of typeInputRadios) {
        if (input.checked) {
          this.onFulfillmentTypeChange(input.value)
        }

        input.addEventListener('change', (event) => {
          self.onFulfillmentTypeChange(event.target.value)
        })
      }
    }

    this.initValuesSerializedEditor();
  }

  onFulfillmentTypeChange(value) {
    const priceFields = document.getElementById(`${ this.form.id }-price-fields`),
    parametersField = document.getElementById(`${ this.form.id }-parameters-field`),
    marketplaceField = document.getElementById(`${ this.form.id }_marketplace_product_id`).closest('.form-group'),
    quickstartField = document.getElementById(`${ this.form.id }_quickstart_url`).closest('.form-group'),
    descriptionField = document.getElementById(`${ this.form.id }_description`).closest('.form-group'),
    packageUrl = document.getElementById(`${ this.form.id }_package_url`).closest('.form-group');

    switch (value) {
      case 'buy':
      case 'trial':
        priceFields.classList.remove('d-none');
        parametersField.classList.remove('d-none');
        marketplaceField.classList.add('d-none');
        quickstartField.classList.add('d-none');
        packageUrl.classList.add('d-none');
        descriptionField.classList.remove('d-none');
        this.disableBillingPeriodValidation(false);
        break;
      case 'call':
        priceFields.classList.add('d-none');
        parametersField.classList.add('d-none');
        marketplaceField.classList.add('d-none');
        quickstartField.classList.add('d-none');
        packageUrl.classList.add('d-none');
        descriptionField.classList.remove('d-none');
        this.disableBillingPeriodValidation(true);
        break;
      case 'marketplace':
        priceFields.classList.add('d-none');
        parametersField.classList.remove('d-none');
        marketplaceField.classList.remove('d-none');
        quickstartField.classList.add('d-none');
        packageUrl.classList.add('d-none');
        descriptionField.classList.add('d-none');
        this.disableBillingPeriodValidation(true);
        break;
      case 'quickstart':
        priceFields.classList.add('d-none');
        parametersField.classList.remove('d-none');
        marketplaceField.classList.add('d-none');
        quickstartField.classList.remove('d-none');
        packageUrl.classList.add('d-none');
        descriptionField.classList.remove('d-none');
        this.disableBillingPeriodValidation(true);
        break;
      case 'download':
        priceFields.classList.add('d-none');
        parametersField.classList.remove('d-none');
        marketplaceField.classList.add('d-none');
        quickstartField.classList.add('d-none');
        packageUrl.classList.remove('d-none');
        descriptionField.classList.remove('d-none');
        this.disableBillingPeriodValidation(true);
        break;
      default:
        throw TypeError(`${ value } is not a valid value for fulfillment type`);
    }
  }

  disableBillingPeriodValidation( disable ) {
    if ( disable ) {
      this.validator.removeFieldValidation(`${ this.form.id }[billing_period]`);
    } else {
      this.validator.addFieldValidation(
        `${ this.form.id }[billing_period]`, 'notBlank',
        { message: 'This value should not be blank.' }
      );
    }
  }

  initValuesSerializedEditor() {
    if ( !this.initiated ) {
      const textarea = document.getElementById(`${ this.form.id }_catalog_item_plan_values_serialized`);
      if ( textarea ) {
        setTimeout(() => {
          const editor = CodeMirror.fromTextArea(textarea, {
              lineNumbers: true,
              mode: 'application/ld+json',
            }
          );
          editor.setSize(null, 230);
        }, 1000);
      }
    }

    this.initiated = true;
  }
}
